<template>
  <Popup
    @hide-popup="$emit('hide-popup')"
  >
    <section class="modal-body z1 rounded-modal responsive-modal">
      <!-- HEADER -->
      <section class="pt2 pb1 px3 flex justify-between items-center invert rounded-top">
        <h3>Sélectionnez les chevaux</h3>
        <div class="flex items-center">
          <button
            class="close-button"
            @click="$emit('hide-popup')"
          >
            ×
          </button>
        </div>
      </section>
      <!-- END HEADER -->

      <!-- BODY -->
      <section class="white-bg pb2 rounded-bottom">
        <div class="px3 pt2">
          <div class="overflow-auto" style="max-height: 300px;">
            <div v-for="(participant, index) in participants" :key="participant.uuid" class="mb3">
              <div class="mb2">
                <label class="block mb1 h6 bold">
                  {{ participant.firstname }} {{ participant.lastname }} :
                </label>
                <select
                  :key="index"
                  v-model="selectedHorses[participant.uuid]"
                  class="col-12 py1 pl2 white-bg h7n mobile-select"
                  @change="refreshAvailableHorses"
                >
                  <option value="">-- Sans cheval --</option>
                  <option
                    v-for="horse in availableHorses(participant.uuid)"
                    :key="horse.uuid"
                    :value="horse"
                  >
                    {{ horse.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div v-if="hasDuplicateHorses" class="mb2 p1 red-bg white">
            <i class="icon icon-attention mr1"></i>
            <span>Un même cheval ne peut pas être sélectionné pour plusieurs participants.</span>
          </div>
        </div>
        <!-- END BODY -->

        <!-- ACTIONS -->
        <section class="mt2 mb1 mx3 flex justify-between mobile-actions">
          <Button
            :action="() => $emit('hide-popup')"
            text="Annuler"
            color="grey-bg"
            class="mobile-button"
          />
          <Button
            :action="confirmSelection"
            text="Confirmer"
            :disabled="hasDuplicateHorses"
            class="mobile-button"
          />
        </section>
        <!-- END ACTIONS -->
      </section>
    </section>
  </Popup>
</template>

<script>
import Popup from '@/components/elements/Popup.vue';
import Button from '@/components/elements/Button.vue';

export default {
  name: 'CustomerHorsesModal',
  components: { Popup, Button },
  props: {
    horses: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return { selectedHorses: {} };
  },
  computed: {
    participants () {
      return this.$store.state.cartItem?.participants || [];
    },
    hasDuplicateHorses () {
      const selectedValues = Object.values(this.selectedHorses).filter(value => value !== '');
      return selectedValues.length !== new Set(selectedValues).size;
    }
  },
  beforeMount () {
    this.initializeSelections();
  },
  methods: {
    initializeSelections () {
      this.participants.forEach(participant => {
        this.selectedHorses[participant.uuid] = '';
      });
    },
    availableHorses (participant) {
      const selectedByOthers = Object.entries(this.selectedHorses)
        .filter(([participantUuid, horseUuid]) => participant !== participantUuid && (horseUuid && horseUuid !== ''))
        .map(([, horseUuid]) => horseUuid);

      return this.horses.filter(horse => !selectedByOthers.includes(horse.uuid));
    },
    confirmSelection () {
      if (!this.hasDuplicateHorses) {
        const horseSelections = {};
        Object.entries(this.selectedHorses).forEach(([participantUuid, horse]) => {
          if (horse && horse.name && horse.uuid) {
            horseSelections[participantUuid] = { uuid: horse.uuid, name: horse.name };
          }
        });
        this.$emit('is-selected-horses', true);
        this.$emit('horses-selected', horseSelections);
        this.$emit('hide-popup');
      }
    },
    refreshAvailableHorses () {
      this.selectedHorses = { ...this.selectedHorses };
    }
  }
};
</script>

<style scoped>
  .responsive-modal {
    width: 50vw;
    min-width: 300px;
    max-width: 500px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .rounded-top {
    border-radius: 12px 12px 0 0;
  }

  .rounded-bottom {
    border-radius: 0 0 12px 12px;
  }

  .close-button {
    background: none;
    border: none;
    color: var(--white);
    font-size: 1.5rem;
    font-weight: bold;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    border-radius: 50%;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
  }

  .close-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .close-button:focus {
    outline: 2px solid var(--light-blue);
    outline-offset: 2px;
  }

  .border-select {
    border: 2px solid var(--grey);
  }

  .grey-bg {
    background-color: var(--medium-grey);
  }

  .grey-bg:hover {
    background-color: var(--dark-grey);
  }

  .mobile-select {
    font-size: 16px;
    padding: 12px 16px ;
    border: 2px solid var(--grey);
    border-radius: 8px;
    width: 100%;
    min-height: 48px;
    background-color: var(--white);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-size: 16px;
    padding-right: 40px;
  }

  .mobile-select:focus {
    border-color: var(--light-blue);
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 166, 198, 0.1);
  }

  .mobile-button {
    min-width: 120px;
    height: 44px ;
    font-size: 0.9rem ;
    border-radius: 8px;
  }

  .mobile-button .btn-cta-text {
    font-size: 0.9rem ;
  }

  @media (max-width: 768px) {
    .responsive-modal {
      width: 90vw;
      min-width: 280px;
      max-width: 400px;
      margin: 1rem;
    }

    .mobile-select {
      font-size: 18px ;
      padding: 16px 20px ;
      min-height: 56px;
    }

    .mobile-actions {
      flex-direction: column;
      gap: 12px;
    }

    .mobile-button {
      width: 100%;
      min-width: unset;
      height: 48px ;
      font-size: 1rem ;
    }

    .mobile-button .btn-cta-text {
      font-size: 1rem ;
    }
  }

  @media (max-width: 480px) {
    .responsive-modal {
      width: 95vw;
      min-width: 260px;
      margin: 0.5rem;
    }

    .mobile-select {
      font-size: 16px ;
      padding: 14px 18px ;
      min-height: 52px;
    }

    .mobile-button {
      height: 46px ;
    }
  }

  @media (max-width: 360px) {
    .responsive-modal {
      width: 98vw;
      min-width: 240px;
      margin: 0.25rem;
    }

    .mobile-select {
      font-size: 15px ;
      padding: 12px 16px ;
      min-height: 48px;
    }
  }
</style>
